import { components as generatedComponents } from "./slices";
import { withSafeRender } from "~/components/atoms/WvSafeRender";

export * from "./slices";
export * from "./type";

// ./slices is Slice Machine generated, so containment is added here instead (WOV-2200).
export const components = withSafeRender(generatedComponents);
